<template>
  <div id="app">
    <!-- 路由的出口 -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
  }
}
</script>
<style lang="less">
  // #app {
  //   font-family: "Avenir", Helvetica, Arial, sans-serif;
  //   -webkit-font-smoothing: antialiased;
  //   -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  //   -moz-osx-font-smoothing: grayscale;
  //   color: #2c3e50;
  //   width: 100%;
  //   height: 100%;
  //   background-color: #fff;
  // }
</style>
